import React from "react";
import { useTranslation } from "react-i18next";
import { FaMicrophone, FaStop } from "react-icons/fa";

/**
 * Agent Mode only: mic at the end of the report editor toolbar. The agent's own
 * mic does the findings; this one dictates straight into the report (edits,
 * additions) with CRE's existing editor dictation — `onToggle` is the page's
 * editor-mic handler (same as F3). The agent stops its own mic before showing
 * the report and stops this one when it leaves the report, so only one mic is
 * ever on.
 */
export default function AgentEditorMicButton({ active, onToggle }) {
  const { t } = useTranslation("common");
  const label = active
    ? t("agentEditorMic.stop", { defaultValue: "Stop dictating" })
    : t("agentEditorMic.start", { defaultValue: "Dictate into the report" });
  return (
    <button
      type="button"
      // Keep the editor's caret: the text goes where the doctor clicked.
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onToggle?.()}
      aria-pressed={!!active}
      aria-label={label}
      title={label}
      data-testid="agent-editor-mic"
      className={`inline-flex h-9 w-9 items-center justify-center rounded-md border transition-colors ${
        active
          ? "border-red-500 bg-red-500 text-white hover:bg-red-600"
          : "border-gray-300 bg-transparent text-gray-700 hover:border-[#A4C639] hover:bg-[#CBEA7B80] dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
      }`}
    >
      {active ? <FaStop className="h-3.5 w-3.5" aria-hidden /> : <FaMicrophone className="h-4 w-4" aria-hidden />}
    </button>
  );
}
